import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Setting } from 'src/app/model/setting.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SettingService {

  private path = environment.apiURL + 'setting';

  constructor(private http: HttpClient) {
  }

  public list(): Observable<Array<Setting>> {
    return this.http
               .get<Setting[]>(this.path);
  }

  public get(name: string): Observable<Setting> {
    return this.http
               .get<Setting>(this.path + '/' + name);
  }

  public save(p: Setting): Observable<Setting> {
    return this.http
               .put<Setting>(this.path,
                         p);
  }

  public saveAll(all: Array<Setting>): Observable<Setting> {
    return this.http
               .patch<Setting>(this.path,
                               all);
  }

  public delete(p: Setting): Observable<void> {
    return this.http
               .delete<void>(this.path + '/' + p.name);
  }
}
